module.exports = __webpack_public_path__ + "img/logo_brand.5717acac.svg";